@if (loaded()) {
<app-route-page>
  <div class="d-flex flex-column psic-gap-8 make-payment-container">
    <h2>Make a payment</h2>
    <app-information-card [field]="policyDataField"></app-information-card>
    <app-information-card [form]="paymentOptionForm" [field]="paymentAmountField"
    (formValid)="updateSelectedField($event)"></app-information-card>

    <div class="payment-option-container d-flex flex-column justify-content-center psic-px-7 psic-py-6">
      <div class="d-flex flex-column psic-gap-6">
        <div class="d-flex flex-row align-items-center psic-gap-4">
          <img src="assets/images/payments.svg" alt="payments" />
          <div class="d-flex flex-column justify-content-center">
            <h6>Payment options</h6>
            <p class="caption">Add payment method</p>
          </div>
        </div>
        <lib-choice-chip class="options" [field]="paymentMethodField"
          (callback)="showOneIncPaymentWidget($event)">
        </lib-choice-chip>
        @if (showOneIncLogo() && !(paymentMethod() == 'ECheck' && accountDetail.eftMethod != 'OneInc')) {
          <div>
            <img src="assets/images/oneInc_logo.svg" alt="Terms-and-Conditions-img" [ngStyle]="{
                    'height': isMobile() ? '40px' : '59px',
                    'width': isMobile() ? '140px' : '188px',
                    'margin-right': isMobile() ? '8px' : '8px'
                }" />
          </div>
        }

          <div id="portalOneContainer"></div>

          @if (paymentMethod() === 'ECheck' && accountDetail.eftMethod === 'Manual') {
            <form class="d-flex flex-column psic-gap-6" [formGroup]="eftpaymentForm">
              <!-- Routing Number -->
              <div class="d-flex flex-column psic-gap-2">
                <input class="caption" type="text" formControlName="routingNumber" placeholder="Routing Number"/>
                @if (f['routingNumber'].touched && f['routingNumber'].invalid) {
                  @if (f['routingNumber'].errors?.['required']) {
                    <span class="error disclaimer">
                      The Routing Number is required
                    </span>
                  }
                  @if (f['routingNumber'].errors?.['minlength'] || f['routingNumber'].errors?.['maxlength']) {
                    <span class="error disclaimer">
                      The Routing Number provided is invalid
                    </span>
                  }
                }
              </div>
              <!-- Account Number -->
              <div class="d-flex flex-column psic-gap-2">
                <input class="caption" type="text" formControlName="accountNumber" placeholder="Account Number"/>
                @if (f['accountNumber'].touched && f['accountNumber'].invalid) {
                  @if (f['accountNumber'].errors?.['required']) {
                    <span class="error disclaimer">
                      The Account Number is required
                    </span>
                  }
                  @if (f['accountNumber'].errors?.['maxlength']) {
                    <span class="error disclaimer">
                      The Account Number provided is invalid
                    </span>
                  }
                }
              </div>
              <!-- Account Holder Name -->
              <div class="d-flex flex-column psic-gap-2">
                <input class="caption" type="text" formControlName="accountHolderName" placeholder="Name On Account"/>
                @if (f['accountHolderName'].touched && f['accountHolderName'].invalid) {
                  @if (f['accountHolderName'].errors?.['required']) {
                    <span class="error disclaimer">
                      The Account Holder Name is required
                    </span>
                  }
                  @if (f['accountHolderName'].errors?.['minlength'] || f['accountHolderName'].errors?.['maxlength']) {
                    <span class="error disclaimer">
                      The Account Holder Name is invalid
                    </span>
                  }
                  @if (f['accountHolderName'].errors?.['pattern']) {
                    <span class="error disclaimer">
                      The Account Holder Name should contain only alphabets
                    </span>
                  }
                }
              </div>
              <lib-input-radio [radioLeft]="true" [field]="eftPaymentMethodField" formControlName="eftMethodType"></lib-input-radio>
            </form>
          }
        </div>
        @if (showOneIncLogo() && showNamedInsured()) {
          <lib-input-toggle [field]="namedInsuredField" [(ngModel)]="namedInsuredField.value"></lib-input-toggle>
        }
      </div>
    </div>
    <app-navigation-footer
      [goBack]="!loadedFromQueryParams()"
      [continue]="true"
      [showButton]="showSubmitButton()"
      [continueButtonText]="'Submit payment'"
      (navigatePage)="proceedPayment($event)"
      [paymentscreen]="true"
      [formData]="paymentOptionForm"
      [processingFeeResponse]="processingFeeResponse"
      [showProcessingFee]="showProcessingFee()"
      >
    </app-navigation-footer>
  </app-route-page>
  <app-footer-image></app-footer-image>
}
